import React from 'react';
import { WrenchIcon, UsersIcon, AwardIcon, TrendingUpIcon } from 'lucide-react';
export function About() {
  return <section id="about" className="relative py-24 text-white overflow-hidden" data-id="element-14">
      {/* Fixed Background Image */}
      <div className="absolute inset-0 w-full h-full" style={{
      backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/ieedrSacyiKmrX5boCqSMy/image.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      zIndex: 0
    }} data-id="element-15">
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/75 to-black/85" data-id="element-16"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10" data-id="element-17">
        <div className="max-w-6xl mx-auto" data-id="element-18">
          {/* Logo Badge */}
          <div className="flex justify-center mb-12" data-id="element-19">
            <div className="relative" data-id="element-20">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vgAD6BMFW6FPpPWQURJJHv/logo_black_bg.jpg" alt="Garrett Auto & Truck Service" className="w-64 h-auto rounded-lg shadow-2xl border-4 border-[#D4AF37]" data-id="element-21" />
            </div>
          </div>

          <h2 className="text-5xl font-bold text-white mb-6 text-center" data-id="element-22">
            About Garrett Auto & Truck Service
          </h2>

          <p className="text-2xl text-[#D4AF37] text-center mb-16 font-medium" data-id="element-23">
            Serving Southeast Michigan Since 1958
          </p>

          {/* Main Content Grid */}
          <div className="grid lg:grid-cols-2 gap-12 mb-16" data-id="element-24">
            {/* Left Column - History */}
            <div className="space-y-6" data-id="element-25">
              <div className="bg-black/60 backdrop-blur-sm p-8 rounded-lg border-l-4 border-[#B1050B]" data-id="element-26">
                <h3 className="text-2xl font-bold text-[#D4AF37] mb-4 flex items-center" data-id="element-27">
                  <TrendingUpIcon size={28} className="mr-3" data-id="element-28" />
                  Our Heritage
                </h3>
                <div className="space-y-4 text-white text-lg leading-relaxed" data-id="element-29">
                  <p data-id="element-30">
                    Founded in <strong className="text-white" data-id="element-31">1958</strong> as a
                    Standard Oil station at Halstead and Grand River, we've been
                    keeping Southeast Michigan moving for over six decades.
                  </p>
                  <p data-id="element-32">
                    In 1978, we moved to our current facility at 24445 Grand
                    River Avenue in Farmington Hills. From servicing farm
                    equipment when Ten Mile was still a dirt road to maintaining
                    corporate fleets today—we've grown with our community every
                    step of the way.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column - Expertise */}
            <div className="space-y-6" data-id="element-33">
              <div className="bg-black/60 backdrop-blur-sm p-8 rounded-lg border-l-4 border-[#D4AF37]" data-id="element-34">
                <h3 className="text-2xl font-bold text-[#D4AF37] mb-4 flex items-center" data-id="element-35">
                  <UsersIcon size={28} className="mr-3" data-id="element-36" />
                  Our Expert Team
                </h3>
                <div className="space-y-4 text-white text-lg leading-relaxed" data-id="element-37">
                  <p data-id="element-38">
                    <strong className="text-white" data-id="element-39">
                      Licensed, certified mechanics
                    </strong>{' '}
                    with over 50 years of collective experience. From brake
                    service to complete engine overhauls—if it has wheels, we
                    can fix it.
                  </p>
                  <p data-id="element-40">
                    <strong className="text-white" data-id="element-41">
                      Well known throughout Southeast Michigan
                    </strong>{' '}
                    for commercial truck expertise. Diesel or gas, passenger car
                    or heavy-duty fleet—our master mechanics keep your vehicles
                    running strong.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Service Philosophy */}
          <div className="bg-black/60 backdrop-blur-sm p-8 rounded-lg border-l-4 border-[#B1050B] mb-16" data-id="element-42">
            <h3 className="text-2xl font-bold text-[#D4AF37] mb-4 flex items-center" data-id="element-43">
              <WrenchIcon size={28} className="mr-3" data-id="element-44" />
              Our Service Philosophy
            </h3>
            <div className="space-y-4 text-white text-lg leading-relaxed" data-id="element-45">
              <p data-id="element-46">
                <strong className="text-white" data-id="element-47">
                  We believe in preventative maintenance.
                </strong>{' '}
                Regular oil changes, filter replacements, and
                manufacturer-recommended services keep your vehicle running
                longer and save you money by preventing costly breakdowns.
              </p>
              <p data-id="element-48">
                From basic maintenance to complex repairs, passenger vehicles to
                commercial fleets—Garrett Auto & Truck Service has been
                Southeast Michigan's trusted choice for over 65 years.
              </p>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid md:grid-cols-4 gap-6 mb-16" data-id="element-49">
            <div className="bg-[#B1050B] p-6 rounded-lg text-center border-2 border-[#D4AF37]" data-id="element-50">
              <div className="text-4xl font-bold text-white mb-2" data-id="element-51">65+</div>
              <div className="text-red-100 font-medium" data-id="element-52">Years in Business</div>
            </div>
            <div className="bg-[#B1050B] p-6 rounded-lg text-center border-2 border-[#D4AF37]" data-id="element-53">
              <div className="text-4xl font-bold text-white mb-2" data-id="element-54">50+</div>
              <div className="text-red-100 font-medium" data-id="element-55">Years Experience</div>
            </div>
            <div className="bg-[#B1050B] p-6 rounded-lg text-center border-2 border-[#D4AF37]" data-id="element-56">
              <div className="text-4xl font-bold text-white mb-2" data-id="element-57">100%</div>
              <div className="text-red-100 font-medium" data-id="element-58">Certified Techs</div>
            </div>
            <div className="bg-[#B1050B] p-6 rounded-lg text-center border-2 border-[#D4AF37]" data-id="element-59">
              <div className="text-4xl font-bold text-white mb-2" data-id="element-60">All</div>
              <div className="text-red-100 font-medium" data-id="element-61">Makes & Models</div>
            </div>
          </div>

          {/* Quality Promise - Separate Section */}
          <div className="bg-gradient-to-br from-[#B1050B] to-[#8A0408] p-10 rounded-lg shadow-2xl border-4 border-black" data-id="element-62">
            <div className="flex items-center justify-center mb-6" data-id="element-63">
              <AwardIcon size={48} className="text-[#D4AF37] mr-4" data-id="element-64" />
              <h3 className="text-4xl font-bold text-white" data-id="element-65">
                Our Quality Promise
              </h3>
            </div>
            <div className="max-w-4xl mx-auto" data-id="element-66">
              <p className="text-white text-xl leading-relaxed text-center mb-6" data-id="element-67">
                Garrett Auto & Truck Service is here to serve you by performing
                the highest quality automotive & truck repairs at fair prices,
                using only proven materials of the highest quality.
              </p>
              <p className="text-red-100 text-xl leading-relaxed text-center mb-6" data-id="element-68">
                Our service is backed by our personal pledge of customer
                satisfaction. We will provide you, our customer, with
                outstanding professional courtesy and service.
              </p>
              <p className="text-white text-2xl font-bold text-center" data-id="element-69">
                And we will stand behind our workmanship.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}